import {JSONSchemaType} from 'ajv'
import {LocationBean} from '@/service/model/LocationBean'

export interface SiteManagerAddressBeanV2 {
  address1?: string | null
  address2?: string | null
  postalCode?: string | null
  city?: string | null
  location?: LocationBean | null
}

export interface SiteManagerSiteBeanV2 {
  id: string
  name: string
  reference?: string | null
  address1?: string | null
  address2?: string | null
  postalCode?: string | null
  city?: string | null
  location?: LocationBean | null
  addresses?: SiteManagerAddressBeanV2[]
}

export const siteManagerAddressBeanV2Schema: JSONSchemaType<SiteManagerAddressBeanV2> = {
  type: 'object',
  properties: {
    address1: {
      type: ['string'],
      nullable: true
    },
    address2: {
      type: ['string'],
      nullable: true
    },
    postalCode: {
      type: ['string'],
      nullable: true
    },
    city: {
      type: ['string'],
      nullable: true
    },
    location: {
      type: 'object',
      properties: {
        latitude: {
          type: 'number',
          minimum: -180,
          maximum: 180
        },
        longitude: {
          type: 'number',
          minimum: -180,
          maximum: 180
        }
      },
      required: ['latitude', 'longitude'],
      nullable: true
    }
  },
  additionalProperties: true
}

export const siteManagerSiteBeanV2Schema: JSONSchemaType<SiteManagerSiteBeanV2> = {
  type: 'object',
  properties: {
    id: {
      type: ['string']
    },
    name: {
      type: ['string']
    },
    reference: {
      type: ['string'],
      nullable: true
    },
    address1: {
      type: ['string'],
      nullable: true
    },
    address2: {
      type: ['string'],
      nullable: true
    },
    postalCode: {
      type: ['string'],
      nullable: true
    },
    city: {
      type: ['string'],
      nullable: true
    },
    location: {
      type: 'object',
      properties: {
        latitude: {
          type: 'number',
          minimum: -180,
          maximum: 180
        },
        longitude: {
          type: 'number',
          minimum: -180,
          maximum: 180
        }
      },
      required: ['latitude', 'longitude'],
      nullable: true
    },
    addresses: {
      type: 'array',
      items: siteManagerAddressBeanV2Schema,
      nullable: true
    }
  },
  required: ['id', 'name'],
  additionalProperties: true
}

export const siteManagerSiteBeanV2ArraySchema: JSONSchemaType<Array<SiteManagerSiteBeanV2>> = {
  type: 'array',
  items: siteManagerSiteBeanV2Schema
}
